/**
 * Reminder System Types
 *
 * Types for the non-user automated reminder system that injects
 * contextual information into messages invisibly to the user.
 */
// ═══════════════════════════════════════════════════════════════════════════
// REMINDER TAGS
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Tag used to wrap automated reminders in messages.
 * Content inside these tags should be:
 * - Used by the AI for context
 * - NOT acknowledged to the user
 * - Stripped from older messages to save tokens
 */
export const REMINDER_TAG = 'non_user_automated_reminder';
export const REMINDER_OPEN_TAG = `<${REMINDER_TAG}>`;
export const REMINDER_CLOSE_TAG = `</${REMINDER_TAG}>`;
/**
 * First-message reminder tag.
 * These reminders are intended to persist across turns and should not be
 * pruned with standard non_user_automated_reminder stripping.
 */
export const FIRST_MESSAGE_REMINDER_TAG = "first_message_reminder";
export const FIRST_MESSAGE_REMINDER_OPEN_TAG = `<${FIRST_MESSAGE_REMINDER_TAG}>`;
export const FIRST_MESSAGE_REMINDER_CLOSE_TAG = `</${FIRST_MESSAGE_REMINDER_TAG}>`;
/**
 * System reminder tag - used at the message level
 */
export const SYSTEM_REMINDER_TAG = 'system_reminder';
export const SYSTEM_REMINDER_OPEN_TAG = `<${SYSTEM_REMINDER_TAG}>`;
export const SYSTEM_REMINDER_CLOSE_TAG = `</${SYSTEM_REMINDER_TAG}>`;
/**
 * Marker to indicate that the NEXT content part (usually an image) is associated
 * with this reminder and should be stripped along with the reminder text.
 *
 * Usage: Include this marker at the END of a reminder text part, before the image.
 * When stripping reminders, any image_url part immediately following a reminder
 * that contains this marker will also be removed.
 */
export const REMINDER_IMAGE_MARKER = '<reminder_has_associated_image/>';
